import React from 'react';
import { helpers } from '@simplybenefits/sb-utils';
import { Chip } from '@mui/material';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';
import CoverageBlock from '../CoverageBlock.js';
import CoverageBlockFull from '../CoverageBlockFull.js';

/**
 *
 * @param {*} props
 */
export default function Vision({ classes, expanded, vision, handleChange, showDependentWarning, waivedEHC }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('vision')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('vision') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Vision</Text>
                    {
                        waivedEHC &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        vision.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    {
                        showDependentWarning &&
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You have waived this benefit for your dependents.
                                </Text>
                            </div>
                    }

                    {
                        vision.isCombinedMaximum ?
                            <>
                                <div style={classes.row}>
                                    <Text small bold margin="10px 0px 10px 0px">
                                        {`You have ${ helpers.formatNumber(vision.eyeExamReimbursement, 2) }% reimbursement for vision services to a combined maximum of ${ helpers.formatNumber(vision.combinedAdultMax, 2, true) } for adults and ${ helpers.formatNumber(vision.combinedChildMax, 2, true) } for children.`}
                                    </Text>
                                </div>

                                <div style={classes.row}>
                                    <Text small bold >
                                        Benefit
                                    </Text>
                                </div>

                                <div>
                                    <Text small margin="5px 0px 10px 0px">
                                        Eye Exam
                                    </Text>
                                    <Text small margin="5px 0px 10px 0px">
                                        Eye Glasses And Contacts
                                    </Text>
                                    <Text small margin="5px 0px 0px 0px">
                                        Required Safety Eye Wear
                                    </Text>
                                </div>
                            
                            </>
                            :
                            <>
                                <div style={classes.row}>
                                    <Text small bold margin="10px 0px 10px 0px">
                                        {
                                            vision.eyeExamReimbursement ? `You have ${ vision.eyeExamReimbursement }% reimbursement for basic eye exams. ` : null
                                        }
                                        {
                                            vision.eyeGlassesAndContactsReimbursement ? `${ vision.eyeGlassesAndContactsReimbursement }% reimbursement for eye glasses and eye wear. ` : null
                                        }
                                        {
                                            vision.requiredSafetyEyeWearReimbursement ? `${ vision.requiredSafetyEyeWearReimbursement }% reimbursement for safety eye wear. ` : null
                                        }
                                    </Text>
                                </div>

                                {
                                    // Temporary
                                    (vision.eyeExamAdultMax === 0 &&
                                    vision.eyeExamChildMax === 0 &&
                                    vision.eyeExamReimbursement === 0 &&
                                    vision.eyeExamRolloverPeriodAdult === 0 &&
                                    vision.eyeExamRolloverPeriodChild === 0 &&
                                    vision.eyeGlassesAndContactsAdultMax === 0 &&
                                    vision.eyeGlassesAndContactsChildMax === 0) ? 
                                        null
                                        : 
                                        <div style={{ marginTop: 10 }}>
                                            <CoverageBlock
                                                title="Benefit"
                                                value="Maximum"
                                                type="header"
                                            />
                                            <CoverageBlockFull
                                                coverage={vision}
                                            />
                                        </div>
                                }
                            </>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}